// extracted by mini-css-extract-plugin
export default {"overlay":"ImagePreview_overlay__KzISy","closeBtn":"ImagePreview_closeBtn__Kf8Md","imageWrapper":"ImagePreview_imageWrapper__uP9Fi"};